import {Injectable} from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {HttpErrorResponse} from "@angular/common/http";

declare let iNet: any;

@Injectable({
    providedIn: 'platform'
})
export class SecurityService {
    private roles: Array<string> = [];

    constructor(private http: HttpClientService) {
    }

    public load(): Promise<any> {
        return new Promise(resolve => {
            if(!window['iNet'] || !iNet.prefix || !iNet.enableLayout || !iNet.username) {
                resolve({});
            } else {
                this.http.postJSON(iNet.getPUrl('system/userrole/list'))
                    .subscribe((obj: any) => {
                        for (let key in obj) {
                            this.append(obj[key]);
                        }
                        resolve(obj);
                    }, (err: HttpErrorResponse) => {
                        resolve({});
                    });
            }
        });
    }

    private parserRoleFrom(obj: Object): Array<string> {
        let roles: Array<string> = [];
        for (let key in obj) {
            if (obj[key] === "true" || obj[key] === true) {
                roles.push(key);
            }
        }
        return roles;
    }

    private uniqueArray(arrArg) {
        return arrArg.filter(function(elem, pos,arr) {
            return arr.indexOf(elem) == pos;
        });
    };

    private append(v: Array<string>): Array<string> {
        //console.log('[append]roles', v);
        this.roles = this.uniqueArray(this.roles.concat(v));
        return this.roles;
    }

    hasRole(v: string): boolean {
        //console.log('[checkRole]=', v);
        let roles = v.split(',');
        if (roles.length > 1) {
            let __items = roles.filter(role => this.roles.indexOf(role) > -1);
            return (__items.length > 0);
        }
        return (this.roles.indexOf(v) > -1);
    }

    /**
     * Check session timeout when system is idle
     */
    ping() {
        if(iNet.isEmpty(iNet.username) || !iNet.enableLayout) {
            return;
        }
        let iframe = document.createElement('iframe');
        iframe.style.display = "none";
        iframe.setAttribute("src", iNet.getPUrl('common/page/ping'));
        iframe.onload = function () {
            const __loginUrl = 'cas/login';
            try {
                let __path = iframe.contentWindow.location.pathname || '';
                let __isLogin = (__loginUrl.match(__path) || []).length > 0;
                if (__isLogin) {
                    window.location.reload();
                }
            } catch (ex) {
                window.location.reload();
            }
            document.body.removeChild(iframe);
        };
        document.body.appendChild(iframe);
    }

}
